<button 
  (click)="isOpen = !isOpen" 
  cdkOverlayOrigin 
  #trigger="cdkOverlayOrigin"
  matRipple
  [class.minimised]="minimised"
  [class.full-size]="!minimised"
  class="account-menu-button">
    <mat-icon svgIcon="logo" class="logo"></mat-icon>
    <div *ngIf="!minimised">{{connectionService?.activeConnection.name}}</div>
    <mat-icon *ngIf="!minimised" class="mat-icon-rtl-mirror chev">chevron_right</mat-icon>
</button>

<ng-template
  cdkConnectedOverlay
  (backdropClick)="close()"
  (detach)="close()"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOffsetY]="-52">
  <div class="account-dialog mat-elevation-z10">
    <div class="header">
        <mat-icon svgIcon="logo" class="logo"></mat-icon>
        <div>Your AutoPilot Account</div>
        <button (click)="isOpen = false" mat-icon-button aria-label="Close">
            <mat-icon class="close">close</mat-icon>
        </button>
    </div>

    <div class="business-selector">
        <a (click)="switchConnection(connection)" *ngFor="let connection of connectionService.connections" class="business">{{connection.name}}</a>
    </div>

    <div class="business-functions">
      <a (click)="navigate('/login')">Manage connection settings</a>
    </div>

    <hr>
    <!-- <div class="permissions">
        <div class="acl-settings">You are an <strong>Admin</strong> on this business</div>

        <div>Learn more about your <a href="#0">permissions</a></div>
    </div>
    <hr> -->

    <div class="account-actions">
        <!-- <a href="#0">Manage your profile</a> -->
        <a (click)="logout()">Signout</a>
    </div>
<!-- 
    <hr>

    <div class="links">
        <a href="#0">Terms</a>
        <a href="#0">Privacy</a>
    </div> -->

  </div>
</ng-template>

<div class="main-navigation">
  <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">

    <!-- Heading elements -->
    <cdk-tree-node *cdkTreeNodeDef="let node; when: hasChild"
                  [style.display]="shouldRender(node) ? 'flex' : 'none'"
                  [class.mobile]="node.mobile"
                  class="tree-node">
      <button type="button"
              matRipple
              class="navigation-button"
              [attr.aria-label]="'Toggle ' + node.name"
              [attr.aria-expanded]="!!node.isExpanded"
              (click)="open(node)"
              [style.visibility]="node.expandable ? 'visible' : 'hidden'"
              [class.level-0]="node.level === 0"
              [class.level-1]="node.level === 1"
              [class.section-active]="node.active"
              [apStatus]="node.status">
        <span class="navigation-content">
          <mat-icon class="menu-icon" *ngIf="node.icon" [svgIcon]="node.icon" aria-hidden="true"></mat-icon>
          <mat-icon class="menu-icon material-menu-icon" *ngIf="node.materialIcon" aria-hidden="true">{{node.materialIcon}}</mat-icon>
          <span class="menu-label" *ngIf="!minimised">{{node.name}}</span>
        </span>
        <mat-icon *ngIf="!minimised" class="expand-icon" aria-hidden="true">{{node.isExpanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
      </button>
    </cdk-tree-node>

    <!-- Children elements -->
    <cdk-tree-node *cdkTreeNodeDef="let node"
                  [style.display]="shouldRender(node) ? 'flex' : 'none'"
                  [class.mobile]="node.mobile"
                  [class.child-node]="node.level > 0"
                  class="tree-node tree-leaf">
      <button type="button"
              matRipple
              class="navigation-button"
              [apStatus]="node.status"
              (click)="navigate(node.route)"
              [class.active]="node.active"
              [class.level-0]="node.level === 0"
              [class.level-1]="node.level === 1">
        <span class="navigation-content">
          <mat-icon class="menu-icon" *ngIf="node.icon" [svgIcon]="node.icon" aria-hidden="true"></mat-icon>
          <mat-icon class="menu-icon material-menu-icon" *ngIf="node.materialIcon" aria-hidden="true">{{node.materialIcon}}</mat-icon>
          <span class="menu-label" *ngIf="!minimised">{{node.name}}</span>
        </span>
      </button>
    </cdk-tree-node>
  </cdk-tree>
</div>
